module.exports = __webpack_public_path__ + "resources/img/img_awesome_secure_trust4.28d3c0cfdfa7c76377ba0f97283f677e.png";